// @ts-nocheck
// TODO: Type fixes

import {
  ConnectedOverlayScrollHandler,
  fadeIn,
  isTouchDevice,
  ZIndexUtils,
  getWindowScrollTop,
  getWindowScrollLeft,
  getOuterWidth,
  getOuterHeight,
  getViewport,
  hasClass,
  findSingle,
  isEmpty,
  uniqueId,
} from "#imports";

function bindEvents ( el ) {
  const modifiers = el.$_ptooltipModifiers;

  if ( modifiers.focus ) {
    el.addEventListener( "focus", onFocus );
    el.addEventListener( "blur", onBlur );
  } else {
    el.addEventListener( "mouseenter", onMouseEnter );
    el.addEventListener( "mouseleave", onMouseLeave );
    el.addEventListener( "click", onClick );
  }

  el.addEventListener( "keydown", onKeydown );
}

function unbindEvents ( el ) {
  const modifiers = el.$_ptooltipModifiers;

  if ( modifiers.focus ) {
    el.removeEventListener( "focus", onFocus );
    el.removeEventListener( "blur", onBlur );
  } else {
    el.removeEventListener( "mouseenter", onMouseEnter );
    el.removeEventListener( "mouseleave", onMouseLeave );
    el.removeEventListener( "click", onClick );
  }

  el.removeEventListener( "keydown", onKeydown );
}

function bindScrollListener ( el ) {
  if ( !el.$_ptooltipScrollHandler ) {
    el.$_ptooltipScrollHandler = new ConnectedOverlayScrollHandler( el, () => {
      hide( el );
    } );
  }

  el.$_ptooltipScrollHandler.bindScrollListener();
}

function unbindScrollListener ( el ) {
  if ( el.$_ptooltipScrollHandler ) {
    el.$_ptooltipScrollHandler.unbindScrollListener();
  }
}

function onMouseEnter ( event ) {
  show( event.currentTarget );
}

function onMouseLeave ( event ) {
  hide( event.currentTarget );
}

function onFocus ( event ) {
  show( event.currentTarget );
}

function onBlur ( event ) {
  hide( event.currentTarget );
}

function onClick ( event ) {
  hide( event.currentTarget );
}

function onKeydown ( event ) {
  if ( event.code === "Escape" ) {
    hide( event.currentTarget );
  }
}

function show ( el ) {
  if ( el.$_ptooltipDisabled ) {
    return;
  }

  const tooltipElement = create( el );

  align( el );
  fadeIn( tooltipElement, 250 );

  window.addEventListener( "resize", function onWindowResize () {
    if ( !isTouchDevice() ) {
      hide( el );
    }

    this.removeEventListener( "resize", onWindowResize );
  } );

  bindScrollListener( el );
  ZIndexUtils.set( "tooltip", tooltipElement, el.$_ptooltipZIndex );
}

function hide ( el ) {
  remove( el );
  unbindScrollListener( el );
}

function getTooltipElement ( el ) {
  return document.getElementById( el.$_ptooltipId );
}

function create ( el ) {
  const id = el.$_ptooltipIdAttr !== "" ? el.$_ptooltipIdAttr : uniqueId() + "_tooltip";

  el.$_ptooltipId = id;

  const container = document.createElement( "div" );

  container.id = id;

  const tooltipArrow = document.createElement( "div" );

  tooltipArrow.className = "a-tooltip-arrow";
  container.appendChild( tooltipArrow );

  const tooltipText = document.createElement( "div" );

  tooltipText.className = "a-tooltip-text";

  if ( el.$_ptooltipEscape ) {
    tooltipText.innerHTML = el.$_ptooltipValue;
  } else {
    tooltipText.innerHTML = "";
    tooltipText.appendChild( document.createTextNode( el.$_ptooltipValue ) );
  }

  container.setAttribute( "role", "tooltip" );
  container.appendChild( tooltipText );
  document.body.appendChild( container );

  container.style.display = "inline-block";

  if ( el.$_ptooltipFitContent ) {
    container.style.width = "fit-content";
  }

  return container;
}

function remove ( el ) {
  if ( el ) {
    const tooltipElement = getTooltipElement( el );

    if ( tooltipElement && tooltipElement.parentElement ) {
      ZIndexUtils.clear( tooltipElement );
      document.body.removeChild( tooltipElement );
    }

    el.$_ptooltipId = null;
  }
}

function align ( el ) {
  const modifiers = el.$_ptooltipModifiers;

  if ( modifiers.top ) {
    alignTop( el );

    if ( isOutOfBounds( el ) ) {
      alignBottom( el );

      if ( isOutOfBounds( el ) ) {
        alignTop( el );
      }
    }
  } else if ( modifiers.left ) {
    alignLeft( el );

    if ( isOutOfBounds( el ) ) {
      alignRight( el );

      if ( isOutOfBounds( el ) ) {
        alignTop( el );

        if ( isOutOfBounds( el ) ) {
          alignBottom( el );

          if ( isOutOfBounds( el ) ) {
            alignLeft( el );
          }
        }
      }
    }
  } else if ( modifiers.bottom ) {
    alignBottom( el );

    if ( isOutOfBounds( el ) ) {
      alignTop( el );

      if ( isOutOfBounds( el ) ) {
        alignBottom( el );
      }
    }
  } else {
    alignRight( el );

    if ( isOutOfBounds( el ) ) {
      alignLeft( el );

      if ( isOutOfBounds( el ) ) {
        alignTop( el );

        if ( isOutOfBounds( el ) ) {
          alignBottom( el );

          if ( isOutOfBounds( el ) ) {
            alignRight( el );
          }
        }
      }
    }
  }
}

function getHostOffset ( el ) {
  const offset = el.getBoundingClientRect();
  const targetLeft = offset.left + getWindowScrollLeft();
  const targetTop = offset.top + getWindowScrollTop();

  return { left: targetLeft, top: targetTop };
}

function alignRight ( el ) {
  preAlign( el, "right" );
  const tooltipElement = getTooltipElement( el );
  const hostOffset = getHostOffset( el );
  const left = hostOffset.left + getOuterWidth( el );
  const top = hostOffset.top + ( getOuterHeight( el ) - getOuterHeight( tooltipElement ) ) / 2;

  tooltipElement.style.left = left + "px";
  tooltipElement.style.top = top + "px";
}

function alignLeft ( el ) {
  preAlign( el, "left" );
  const tooltipElement = getTooltipElement( el );
  const hostOffset = getHostOffset( el );
  const left = hostOffset.left - getOuterWidth( tooltipElement );
  const top = hostOffset.top + ( getOuterHeight( el ) - getOuterHeight( tooltipElement ) ) / 2;

  tooltipElement.style.left = left + "px";
  tooltipElement.style.top = top + "px";
}

function alignTop ( el ) {
  preAlign( el, "top" );
  const tooltipElement = getTooltipElement( el );
  const hostOffset = getHostOffset( el );
  const left = hostOffset.left + ( getOuterWidth( el ) - getOuterWidth( tooltipElement ) ) / 2;
  const top = hostOffset.top - getOuterHeight( tooltipElement );

  tooltipElement.style.left = left + "px";
  tooltipElement.style.top = top + "px";
}

function alignBottom ( el ) {
  preAlign( el, "bottom" );
  const tooltipElement = getTooltipElement( el );
  const hostOffset = getHostOffset( el );
  const left = hostOffset.left + ( getOuterWidth( el ) - getOuterWidth( tooltipElement ) ) / 2;
  const top = hostOffset.top + getOuterHeight( el );

  tooltipElement.style.left = left + "px";
  tooltipElement.style.top = top + "px";
}

function preAlign ( el, position ) {
  const tooltipElement = getTooltipElement( el );

  tooltipElement.style.left = -999 + "px";
  tooltipElement.style.top = -999 + "px";
  tooltipElement.className = `a-tooltip a-component a-tooltip-${position} ${el.$_ptooltipClass || ""}`;
}

function isOutOfBounds ( el ) {
  const tooltipElement = getTooltipElement( el );
  const offset = tooltipElement.getBoundingClientRect();
  const targetTop = offset.top;
  const targetLeft = offset.left;
  const width = getOuterWidth( tooltipElement );
  const height = getOuterHeight( tooltipElement );
  const viewport = getViewport();

  return targetLeft + width > viewport.width || targetLeft < 0 || targetTop < 0 || targetTop + height > viewport.height;
}

function getTarget ( el ) {
  return hasClass( el, "a-inputwrapper" ) ? findSingle( el, "input" ) : el;
}

function getModifiers ( options ) {
  // modifiers
  if ( options.modifiers && Object.keys( options.modifiers ).length ) {
    return options.modifiers;
  }

  // arg
  if ( options.arg && typeof options.arg === "object" ) {
    return Object.entries( options.arg ).reduce( ( acc, [key, val] ) => {
      if ( key === "event" || key === "position" ) {
        acc[val] = true;
      }

      return acc;
    }, {} );
  }

  return {};
}

const Tooltip = {
  beforeMount ( el, options ) {
    const target = getTarget( el );

    target.$_ptooltipModifiers = getModifiers( options );

    if ( !options.value ) {
      return;
    } else if ( typeof options.value === "string" ) {
      target.$_ptooltipValue = options.value;
      target.$_ptooltipDisabled = false;
      target.$_ptooltipEscape = false;
      target.$_ptooltipClass = null;
      target.$_ptooltipFitContent = true;
      target.$_ptooltipIdAttr = "";
    } else if ( typeof options.value === "object" && options.value ) {
      if ( isEmpty( options.value.value ) || options.value.value.trim() === "" ) {
        return;
      } else {
        /* eslint-disable */
        target.$_ptooltipValue = options.value.value;
        target.$_ptooltipDisabled = !!options.value.disabled === options.value.disabled ? options.value.disabled : false;
        target.$_ptooltipEscape = !!options.value.escape === options.value.escape ? options.value.escape : false;
        target.$_ptooltipClass = options.value.class;
        target.$_ptooltipFitContent = !!options.value.fitContent === options.value.fitContent ? options.value.fitContent : true;
        target.$_ptooltipIdAttr = options.value.id || '';
      }
    }

    target.$_ptooltipZIndex = options.instance.$primevue && options.instance.$primevue.config && options.instance.$primevue.config.zIndex.tooltip;
    bindEvents(target);
  },
  unmounted(el) {
    let target = getTarget(el);
    remove(target);
    unbindEvents(target);

    if (target.$_ptooltipScrollHandler) {
      target.$_ptooltipScrollHandler.destroy();
      target.$_ptooltipScrollHandler = null;
    }
  },
  updated(el, options) {
    let target = getTarget(el);
    target.$_ptooltipModifiers = getModifiers(options);

    if (!options.value) {
      unbindEvents(target);
      return;
    }

    if (typeof options.value === 'string') {
      target.$_ptooltipValue = options.value;
      target.$_ptooltipDisabled = false;
      target.$_ptooltipEscape = false;
      target.$_ptooltipClass = null;
      target.$_ptooltipIdAttr = '';

      bindEvents(target);
    } else if (typeof options.value === 'object' && options.value) {
      if (isEmpty(options.value.value) || options.value.value.trim() === '') {
        unbindEvents(target);
        return;
      } else {
        /* eslint-disable */
        target.$_ptooltipValue = options.value.value;
        target.$_ptooltipDisabled = !!options.value.disabled === options.value.disabled ? options.value.disabled : false;
        target.$_ptooltipEscape = !!options.value.escape === options.value.escape ? options.value.escape : false;
        target.$_ptooltipClass = options.value.class;
        target.$_ptooltipFitContent = !!options.value.fitContent === options.value.fitContent ? options.value.fitContent : true;
        target.$_ptooltipIdAttr = options.value.id || '';

        bindEvents(target);
      }
    }
  }
};

export default Tooltip;
